import {SeasonName} from '@Libraries/seasons.library';
import {isBrandKitsHalloweenSeason} from '@Libraries/brands-library';
import {getBrandsHalloweenPopupText} from '@Libraries/brands-library';
import {isChristmasSeason} from '@Utils/seasonal-promotion.util';

export const getEndpointForGetUserHasSeenSeasonalBrandkit = (season: SeasonName): string => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return 'brand/getUserHasSeenHalloweenBrandkitPopover';
    default:
      throw new Error(`Unhandled season ${season}`);
  }
};

export const getEndpointForSetUserHasSeenSeasonalBrandkit = (season: SeasonName): string => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return 'brand/setUserHasSeenHalloweenBrandkitPopover';
    default:
      throw new Error(`Unhandled season ${season}`);
  }
};

export const getImageFilenameForSeasonalBrandkitPopover = (season: SeasonName): string => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return 'halloween-brandkit-popover';
    default:
      throw new Error(`Unhandled season ${season}`);
  }
};

export const getTextForSeasonalBrandkitPopover = (season: SeasonName): string => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return getBrandsHalloweenPopupText();
    default:
      throw new Error(`Unhandled season ${season}`);
  }
};

export const isSeasonCurrentlyActive = (season: SeasonName): boolean => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return isBrandKitsHalloweenSeason();

    case SeasonName.CHRISTMAS:
      return isChristmasSeason();

    default:
      throw new Error(`Unhandled season ${season}`);
  }
};

export const doesSeasonHaveBrandkit = (season: SeasonName): boolean => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return true;
    case SeasonName.CHRISTMAS:
      return false;
    default:
      throw new Error(`Unhandled season ${season}`);
  }
};
